import Navbar from './components/Navbar';

import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Home from './Pages/Home';
import InvestWithUs from './Pages/InvestWithUs';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Careers from './Pages/Careers';
import OurProcess from './Pages/OurProcess';
import FAQs from './Pages/FAQs';
import Reviews from './Pages/Reviews';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import RecentProperties from './Pages/RecentProperties';
import PropertyDetail from './Pages/PropertyDetail';
import AddProperty from './Pages/AddProperty';
import DeleteProperty from './Pages/DeleteProperty';
import LoginPage from './Pages/LoginPage';
import PrivateRoute from './Pages/PrivateRoute';

const App = () => {
  return (
    <main className="bg-black">
      <Navbar />
      <div className=''>
     
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/invest-with-us" element={<InvestWithUs />} />
          <Route path="/about" element={<About/>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/our-process" element={<OurProcess />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/recent-properties" element={<RecentProperties />} />
          <Route path="/recent-properties/detail/:id" element={<PropertyDetail />} />
          <Route path="/add-property" element={<PrivateRoute><AddProperty /></PrivateRoute>} />
          <Route path="/delete-property" element={<PrivateRoute><DeleteProperty /></PrivateRoute>} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
  
      <Footer />
      </div>
    </main>
  )
}

export default Sentry.withProfiler(App);
